import { Settings2Icon } from '@air/design-icons';

export type SearchCommandFilterCountProps = {
  count: number;
};

export const SearchCommandFilterCount = ({ count }: SearchCommandFilterCountProps) => {
  return (
    <div className="absolute top-1/2 right-4 flex shrink-0 -translate-y-1/2 items-center">
      <div className="flex size-4 items-center justify-center">
        <Settings2Icon size="xs" />
      </div>
      <div className="flex h-4 min-w-[16px] items-center justify-center rounded-2 ads:bg-ads-gray-4 bg-gray-4 px-1 font-bold ads:text-metadata text-10 text-gray-10">
        {count}
      </div>
    </div>
  );
};
